// removed by extract-text-webpack-plugin
module.exports = {"purchaseConversion":"purchaseConversion__1U40-","purchaseImage":"purchaseImage__2CapD","purchaseDetail":"purchaseDetail__3CEn1","purchaseTitle":"purchaseTitle__RgyeA","purchaseDesc":"purchaseDesc__2IQZH","purchaseContent":"purchaseContent__2izpA","purchaseButton":"purchaseButton__3dpk6","purchaseChannelLabel":"purchaseChannelLabel__b6u5J"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Conversion/Purchase/index.css
// module id = 1375
// module chunks = 0